import React from 'react';
import CustomerScreen from '../components/customerScreen/CustomerScreen';

const CustomerScreenPage: React.FC = () => {
  return <CustomerScreen />;
};

export default CustomerScreenPage; 